import * as Types from '../../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type JobRunTimelineRecordFragment = { __typename: 'JobTaskEvent', id: string, eventType: Types.JobTaskEventType, message?: string | null, observedAt: string, durationSeconds?: number | null, instanceName?: string | null, machineType?: string | null, zone?: string | null, queueGroup?: string | null, performedByName?: string | null, taskKey: string, taskLegacyId?: number | null, taskUuid?: string | null, resourceGroupId?: Types.ResourceGroupId | null, advanceReason?: Types.CascadeAdvanceReason | null, memoryStats?: any | null };

export type JobRunTimelineQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type JobRunTimelineQuery = { __typename: 'Query', job: { __typename: 'Job', id: string, taskEvents: Array<{ __typename: 'JobTaskEvent', id: string, eventType: Types.JobTaskEventType, message?: string | null, observedAt: string, durationSeconds?: number | null, instanceName?: string | null, machineType?: string | null, zone?: string | null, queueGroup?: string | null, performedByName?: string | null, taskKey: string, taskLegacyId?: number | null, taskUuid?: string | null, resourceGroupId?: Types.ResourceGroupId | null, advanceReason?: Types.CascadeAdvanceReason | null, memoryStats?: any | null }> } };

export const JobRunTimelineRecordFragmentDoc = gql`
    fragment JobRunTimelineRecord on JobTaskEvent {
  id
  eventType
  message
  observedAt
  durationSeconds
  instanceName
  machineType
  zone
  queueGroup
  performedByName
  taskKey
  taskLegacyId
  taskUuid
  resourceGroupId
  advanceReason
  memoryStats
}
    `;
export const JobRunTimelineDocument = gql`
    query jobRunTimeline($id: ID!) {
  job(id: $id) {
    id
    taskEvents {
      ...JobRunTimelineRecord
    }
  }
}
    ${JobRunTimelineRecordFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobRunTimelineGQL extends Apollo.Query<JobRunTimelineQuery, JobRunTimelineQueryVariables> {
    override document = JobRunTimelineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }